module.exports = __webpack_public_path__ + "static/media/other.6d2a7bc7.svg";